import React, {useState, useEffect} from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  Button,
  Spinner,
  Col,
  Input,
  Row,
  FormGroup,
  Label
} from "reactstrap";
import LaddaButton, {EXPAND_RIGHT} from "react-ladda";
import PropTypes from "prop-types";
import {FormField, SelectFormField, CustomFormInput, CheckFormField} from "../../../utils/FormFields";
import {BankAccountStatus} from "../Account/types";
import Autosuggest from "../../AutosuggestCompliance";
import { OptionsWhyWithoutTIN } from "../Person/types";


const parseFiscal = (fiscal) => {
  if (fiscal) {
    return {
      PersonFiscalResidenceCountryId: fiscal.PersonFiscalResidenceCountryId,
      PersonFiscalResidenceCountryIso: fiscal.PersonFiscalResidenceCountryIso,
      PersonFiscalResidenceCountryName:fiscal.PersonFiscalResidenceCountryName,
      PersonFiscalResidenceTin: fiscal.PersonFiscalResidenceTin,
      PersonFiscalResidenceTaxId: fiscal.PersonFiscalResidenceTaxId,
      PersonFiscalResidenceTaxIdName: fiscal.PersonFiscalResidenceTaxIdName,
      PersonFiscalResidenceDateFrom: fiscal.PersonFiscalResidenceDateFrom,
      PersonFiscalResidenceDateTo: fiscal.PersonFiscalResidenceDateTo,
      PersonFiscalResidenceId: fiscal.PersonFiscalResidenceId,
      PersonFiscalResidenceNoTINOpt : fiscal.PersonFiscalResidenceNoTINOpt,
      PersonFiscalResidenceAddress : fiscal.PersonFiscalResidenceAddress,
    };
  }
  return undefined;
};


const ModalFiscalResidence = ({
  open,
  errors,
  toggle,
  loading,
  onSave,
  archives,
  document,
  initial,
  services,
  person,
}) => {


  const [fiscalresidence, setFiscalResidence] = useState(
    parseFiscal(initial) || {
      PersonFiscalResidenceCountryId: "",
      PersonFiscalResidenceCountryIso: "",
      PersonFiscalResidenceCountryName: "",
      PersonFiscalResidenceTin: "",
      PersonFiscalResidenceTaxId: undefined,
      PersonFiscalResidenceTaxIdName: "",
      PersonFiscalResidenceDateFrom: undefined,
      PersonFiscalResidenceDateTo: undefined,
      PersonFiscalResidenceId: 0,
      PersonFiscalResidenceAddress : "",
    }
  );

  const [documentCountry, setDocumentCountry] = useState(
    initial ? initial.PersonFiscalResidenceCountryName : ""
  );


  const onChangeDocumentCountry = name => setDocumentCountry(name);

  const fetchCountrySuggestion = name =>
    new Promise((resolve, reject) => {
      services.fetchAutosuggestCoutries({text: name}, response => {
        if (response && response.countries) {
          const suggestions = [];
          response.countries.map(c => {
            suggestions.push({
              id: c.Id,
              name: c.Name
            });
            return {};
          });
          resolve(suggestions);
        } else {
          reject();
        }
      });
    });

    const handleChangeDocumentCountry = (id, value) => {
      onChange("PersonDocumentIssueCountryId", id, value);
      setDocumentCountry(value);
      setFiscalResidence(d => ({
        ...d,
        PersonFiscalResidenceCountryId: id,
        PersonFiscalResidenceCountryName: value,
      }));

    };
  

  const onChange = (name, value, countryName) => {
    const newFiscalResidence = {
      ...fiscalresidence,
      [name]: value
    };
    if (name === "PersonFiscalResidenceCountryName") {
      newFiscalResidence.PersonFiscalResidenceCountryName = countryName;
    }
    if (name === "PersonFiscalResidenceTaxId") {
      document.map(d => {
        if (d.DocumentTypeId === value) {
          newFiscalResidence.PersonFiscalResidenceTaxId = d.DocumentTypeId; 
          newFiscalResidence.PersonFiscalResidenceTaxIdName = d.DocumentTypeName; 
        }
        return {};
      });
    }
    setFiscalResidence({
      ...newFiscalResidence
    });
  };

  useEffect(() => {
    if (document && !initial) {
      setFiscalResidence(d => ({
        ...d,
        PersonFiscalResidenceTaxId: document[0].DocumentTypeName,
      }));
    }
    if (initial) {
      setFiscalResidence(d => ({
        ...d,
        PersonFiscalResidenceCountryId: initial.PersonFiscalResidenceCountryId,
        PersonFiscalResidenceCountryIso: initial.PersonFiscalResidenceCountryIso,
        PersonFiscalResidenceCountryName:initial.PersonFiscalResidenceCountryName,
        PersonFiscalResidenceTin: initial.PersonFiscalResidenceTin,
        PersonFiscalResidenceTaxId: initial.PersonFiscalResidenceTaxId,
        PersonFiscalResidenceTaxIdName: initial.PersonFiscalResidenceTaxIdName,
        PersonFiscalResidenceDateFrom:  initial.PersonFiscalResidenceDateFrom === '0000-00-00T00:00:00'? new Date() :  initial.PersonFiscalResidenceDateFrom,
        PersonFiscalResidenceDateTo: initial.PersonFiscalResidenceDateTo === '0000-00-00T00:00:00'? new Date() :  initial.PersonFiscalResidenceDateTo,
        PersonFiscalResidenceId: initial.PersonFiscalResidenceId,
        PersonFiscalResidenceNoTINOpt : initial.PersonFiscalResidenceNoTINOpt,
        PersonFiscalResidenceAddress : initial.PersonFiscalResidenceAddress,

      }));
      setDocumentCountry(initial.PersonFiscalResidenceCountryName)
    }
  }, [document, initial]);

  return (
    <Modal isOpen={open} toggle={toggle}>
     <ModalHeader toggle={toggle}>
          {initial === undefined ? "New " : "Edit "}
          Fiscal Residence
        </ModalHeader>
      <ModalBody>
        <Form>
        <CustomFormInput label="Fiscal Residence Country">
          <Autosuggest
              value={documentCountry}
              onChange={onChangeDocumentCountry}
              fecthSuggestions={fetchCountrySuggestion}
              onSelect={handleChangeDocumentCountry}
            />
          </CustomFormInput>
          <FormField
            label="Fiscal Residence TIN: "
            name="PersonFiscalResidenceTin"
            onChange={onChange}
            value={fiscalresidence.PersonFiscalResidenceTin}
            type="text"
          />
          {fiscalresidence.PersonFiscalResidenceTin === '' && 
          <SelectFormField
          label="Option: "
          value={fiscalresidence.PersonFiscalResidenceNoTINOpt}
          name="PersonFiscalResidenceNoTINOpt"
          onChange={onChange}
          selectItems={OptionsWhyWithoutTIN}
          getSelectItemId={(item) => item.id}
          getSelectItemName={(item) => item.text}
          />}
          
          {document ? (
            <SelectFormField
              label="Tin Type: "
              name="PersonFiscalResidenceTaxId"
              onChange={onChange}
              value={fiscalresidence.PersonFiscalResidenceTaxId}
              selectItems={[{DocumentTypeId: "", DocumentTypeName: ""}].concat(document)}
              getSelectItemId={i => i.DocumentTypeId}
              getSelectItemName={i => i.DocumentTypeName}
            />
          ) : (
            <Spinner size="sm" />
          )}
          <FormField
            label="Date From: "
            name="PersonFiscalResidenceDateFrom"
            onChange={onChange}
            value={fiscalresidence.PersonFiscalResidenceDateFrom === '0000-00-00T00:00:00'? new Date() : fiscalresidence.PersonFiscalResidenceDateFrom}
            type="date"
          />
           <FormField
            label="Date To: "
            name="PersonFiscalResidenceDateTo"
            onChange={onChange}
            value={fiscalresidence.PersonFiscalResidenceDateTo === '0000-00-00T00:00:00'? new Date() : fiscalresidence.PersonFiscalResidenceDateTo}
            type="date"
          />
           <FormField
            label="Address: "
            value={fiscalresidence.PersonFiscalResidenceAddress}
            name="PersonFiscalResidenceAddress"
            onChange={onChange}
            type="text"
          />
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={loading}
          onClick={() => onSave(fiscalresidence)}
          data-style={EXPAND_RIGHT}
        >
          {loading ? " Saving" : " Save"}
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
}

ModalFiscalResidence.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  document: PropTypes.array,
  initial: PropTypes.object,
};

ModalFiscalResidence.defaultProps = {
 document : undefined,
};

export default ModalFiscalResidence;
